import {
  type AnySection,
  type Condition,
  type MyWidgetsSection,
  SectionType,
  type Category,
  CategoryId,
} from '@wix/add-panel-common';
import type { AddPanelEnhanceDataOptions } from './index';

const MY_WIDGETS_SECTION_AUTOMATION_ID = 'add-panel-section-myWidgetsSection';
const MY_WIDGETS_CUSTOM_GROUP = 'MyWidgets';
const MY_WIDGETS_CATEGORY = '23113458-8893-4ec0-b18a-aad664d64de2';

interface MyWidgetItem {
  id: string;
  title: string;
  desc: string;
  tooltipContent?: string;
}

interface MyWidgetApp {
  id: string;
  title: string;
  props: {
    items: MyWidgetItem[];
  };
}

const getGroupedSections = (app: MyWidgetApp): AnySection[] => {
  const uniqueSectionIds = [
    ...new Set<string>(app.props.items.map(({ id }: MyWidgetItem) => id)),
  ];
  const groupedSectionsById = uniqueSectionIds.reduce(
    (sections, id, index) => {
      const items = app.props.items.filter(
        (item: MyWidgetItem) => item.id === id,
      );
      const title = items[0].title;
      const tooltipContent = items[0].tooltipContent;
      sections[id] = {
        props: {
          items: items.map(({ tooltipContent: _tooltipContent, ...item }) => ({
            ...item,
            desc: items.length > 1 ? item.desc : '',
          })),
        },
        showSectionHeader: false,
        hide: false,
        systemId: `${id}_${app.id}`,
        groupIds: [app.id],
        conditions: [] as Condition[],
        appId: app.id,
        sectionName: app.id,
        title,
        automationId: MY_WIDGETS_SECTION_AUTOMATION_ID,
        translations: {
          shouldTranslate: false,
          subNavigationTitle: title,
          title: '',
          presetTitle: title,
        },
        type: SectionType.MyWidgets,
        index,
        noSpaceBeforeSection: false,
        ...(tooltipContent ? { tooltipContent } : {}),
      } as MyWidgetsSection;
      return sections;
    },
    {} as { [key: string]: AnySection },
  );
  return Object.entries(groupedSectionsById).map(([, section]) => section);
};

export const myWidgetsAddPanelEnhancer = (
  categories: Category[],
  addPanelEnhanceDataOptions: AddPanelEnhanceDataOptions,
): void => {
  if (addPanelEnhanceDataOptions.myWidgets) {
    const myWidgetsCategory = categories?.find(
      ({ id }) => id === CategoryId.InstalledApps,
    );
    if (myWidgetsCategory) {
      myWidgetsCategory.groups = addPanelEnhanceDataOptions.myWidgets.map(
        (app: MyWidgetApp, index: number) => ({
          customGroupType: MY_WIDGETS_CUSTOM_GROUP,
          categoryIds: [MY_WIDGETS_CATEGORY],
          systemId: app.id,
          id: app.id,
          title: app.title,
          translations: {
            title: app.title,
            shouldTranslate: false,
          },
          index,
          noDivider: false,
          sections: getGroupedSections(app),
        }),
      );
    }
  }
};
